/** Top-level view switcher. Renders as a horizontal row on desktop and
 *  a fixed bottom tab bar on mobile — same markup, CSS-only difference.
 *  Each tab has an emoji icon that's only visually shown on the mobile
 *  bottom bar (hidden on desktop via CSS) so the cramped bottom-nav
 *  variant stays scannable without reading every label. */
import { state, currentView } from "../state/store";
import type { JSX } from "preact";
import type { ViewKey } from "../types";

interface TabDef {
  key: ViewKey;
  label: string;
  icon: string;
  adminOnly?: boolean;
}

const TABS: TabDef[] = [
  { key: "my", label: "My calendar", icon: "📅" },
  { key: "company", label: "Company", icon: "👥" },
  { key: "dashboard", label: "Dashboard", icon: "📊", adminOnly: true },
  { key: "equipment", label: "Equipment", icon: "🎥" },
  { key: "directory", label: "Directory", icon: "📇" },
];

export function Tabs(): JSX.Element {
  const isAdmin = state.value.isAdmin;
  return (
    <nav class="view-tabs" role="tablist" aria-label="Main views">
      {TABS.filter((t) => isAdmin || !t.adminOnly).map((t) => {
        const active = currentView.value === t.key;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            class={active ? "active" : ""}
            aria-selected={active}
            onClick={() => (currentView.value = t.key)}
          >
            <span class="tab-icon" aria-hidden="true">{t.icon}</span>
            <span class="tab-label">{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
